import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class ShapeNameFromImageModel extends QuestionExtendedModel {

  model: {
    shape: string,
    possibleAnswers: string[],
    numAnswers: number
  } = {
    shape: Enums.Shapes.circle,
    possibleAnswers: [],
    numAnswers: 3
  };

  static generateModel(json: any): ShapeNameFromImageModel {

    const q = new ShapeNameFromImageModel();

    const model = json.model;

    if (model) {

      if (model.possibleAnswers instanceof Array) {
        q.model.possibleAnswers = model.possibleAnswers;
      }

      q.model.shape = model.shape;
      q.model.numAnswers = model.numAnswers;

    }

    return q;

  }

}
